import './MonthPayment.css';

import { IonButton, IonContent, IonIcon, IonLabel, IonPage, IonSegmentButton, IonSlide, IonSlides, useIonAlert } from '@ionic/react';
import { cardOutline, helpCircleOutline, wifiOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';

import LoadingContainer from '../../../components/loading/LoadingContainer';
import Segment from '../../../components/segments/Segment';
import LayoutGap from '../../../layouts/LayoutGap';
import Toolbar from '../../../layouts/Toolbar';
import { CheckAidAction } from '../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import Offline from './Offline';
import Online from './Online';
import { useHistory } from 'react-router';

interface Props {
    auth?: boolean
}

const MonthPayment: React.FC<Props> = (props) => {
    const history = useHistory();

    const slideValues = ["online", "offline"]
    const [defaultSlide, setDefaultSlide] = useState("online");
    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const [alert] = useIonAlert();

    const dispatch = useAppDispatch()
    const { loading, checkAid } = useAppSelector(state => state.checkAid)

    useEffect(() => {
        if (props.auth) dispatch(CheckAidAction())
    }, [dispatch])

    const segmentClickHandler = (value: any) => {
        setDefaultSlide(value)

        let index = slideValues.findIndex((item) => {
            return item == value
        })

        sliderRef.current?.slideTo(index);
    }

    const slideChangeHandler = async () => {
        var index = await sliderRef.current?.getActiveIndex()
        setDefaultSlide(slideValues[index as number])
    }

    const showInfoHandler = () => {
        alert({
            cssClass: "alert-info",
            message: "کمک های ماهانه و ثابت شما صرف کلیه امور انجمن نذرطبیعت از قبیل ساخت آبشخور ، تأمین علوفه ، حمایت از محیط بانان ، درمان حیات‌وحش مصدوم و... که به صورت فوری نیاز به کمک دارند یا در پروژه هایی که تأمین مالی آنها صددرصد محقق نشده باشد خواهد شد و گزارش کامل این قبیل پروژه ها به محض انجام در سایت قرار خواهد گرفت و به اطلاع شما خواهد رسید. در ضمن هزینه های جاری انجمن از قبیل طراحی و نگهداری سایت و... با تصویب هیئت مدیره از کمکهای رسیده از این صفحه تأمین خواهد شد.<br>برای اطلاع از موجودی صندوق ماهیانه و ریز هزینه کرد مشاهده صندوق ذخیره را کلیک کنید.",
            buttons: [
                {
                    text: "مشاهده صندوق ذخیره", handler: () => {
                        history.push("/fund");
                    }
                },
                { text: "متوجه شدم" }
            ]
        })
    }

    const View = <IonPage className="monthly-payment">
        <Toolbar title={props.auth ? "پرداخت ماهیانه" : "واریز و پرداخت"} hasBackButton>
            <IonButton shape="round" onClick={showInfoHandler}>
                <IonIcon icon={helpCircleOutline} />
            </IonButton>
        </Toolbar>

        <LayoutGap />

        <IonContent className="main-content">
            <Segment defaultSlide={defaultSlide} change={(e: any) => segmentClickHandler(e.detail.value)}>
                <IonSegmentButton layout="icon-start" value="online">
                    <IonIcon icon={wifiOutline} size="small" />
                    <IonLabel>آنلاین</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton layout="icon-start" value="offline">
                    <IonIcon icon={cardOutline} size="small" />
                    <IonLabel>سایر</IonLabel>
                </IonSegmentButton>
            </Segment>

            <IonSlides ref={sliderRef} onIonSlideDidChange={slideChangeHandler}>
                <IonSlide>
                    <Online auth={props.auth!} obligation={checkAid.obligation} amount={checkAid.amount} />
                </IonSlide>
                <IonSlide>
                    <Offline auth={props.auth!} />
                </IonSlide>
            </IonSlides>
        </IonContent>
    </IonPage>;

    return props.auth ?
        <LoadingContainer loading={loading}>
            {View}
        </LoadingContainer>
        : View
}

export default MonthPayment